import React, { useState } from "react";
import EsquinerosArriba from "../components/EsquinerosArriba";
import EsquinerosAbajo from "../components/EsquinerosAbajo";

export default function MensajesJesus() {
  const [fontSizes, setFontSizes] = useState(16);

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };
  return (
    <>
      <div style={{ paddingTop: "3.25rem" }}>
        <EsquinerosArriba />
      </div>
      <div className="container px-md-4">
        <div id="mensajes-body" className={"font-" + fontSizes}>
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Mensajes dados por <br /> Nuestro Señor Jesucristo
              </h3>
              <h5>13/07/1990 al 13/09/1997</h5>
              <h5>Salta - Argentina</h5>
            </div>
            <div className="col-12 mt-5">
              <h6>1 de Abril de 1995</h6>
              <p>
                En este día mientras hacía el vía crucis (en mi dormitorio, tuve
                la siguiente visión) <br />
                <br />
                Vi delante del Sagrario de la parroquia, el Corazón herido de
                Jesús, el Corazón tenía una profunda herida, y cuando latía, de
                la herida salía una gota gruesa de Sangre que se derramaba. A la
                vez El Señor me daba a conocer el sufrimiento que había en ese
                espasmo, al salir las gotas de Sangre, dolor físico y moral, era
                algo tan inenarrable ese dolor, que al transmitírmelo El Señor,
                yo no pude soportarlo y comencé a desmayarme, y sentí que mi
                corazón no resistiría, pero El Señor me lo quitó, pues de no
                haberlo hecho yo habría muerto. <br />
                <br />
                El Señor me mostró cuanto AMOR hay en su Corazón Adorado,
                ¡Cuanto AMOR guarda El en el Sagrario VIVO y PRESENTE! ¡Inmenso,
                Infinito AMOR por nosotros, sufriendo a través de los siglos Su
                Pasión Salvadora!. <br />
                La Trinidad Santa, está presente en el Sacratísimo Corazón
                Eucarístico de Jesús. <br />
                <br />
                Luego de terminar esta visión aparecen estas palabras: <br />
                <br />
                “YO SOY EL SACRATISIMO CORAZON EUCARISTICO DE JESUS, ADORADME
                PERPETUAMENTE EN REPARACION”; y me inspiró la siguiente oración
                para ser rezada a los pies del Sagrario. <br />
                <br />
                Sacratísimo Corazón Eucarístico de Jesús, Yo Confío inmensamente
                en Tu Misericordia. Te pido humildemente que me des la fe que
                necesito para abandonarme a tu Infinita Misericordia, por que ya
                se han agotado mis recursos humanos y ahora sólo me cabe
                volverme con confianza a tu Infinita Compasión, porque sé que TU
                no desoirás mi súplica. Aquí estoy Señor a tus pies pidiendo con
                fervor arregles todas mis cosas y problemas, según tu Amor y
                beneplácito divino, que sé, será lo mejor para mí, concédeme lo
                que te estoy pidiendo, si es para bien de mi alma. <br />
                <br />
                ¡Toma Señor! Mi problema. <br />
                ¡Toma, mi corazón ! Yo confío en Tí, Corazón Eucarístico de
                Jesús. <br />
                ¡Yo Confío en Tí Corazón Eucarístico de Jesús! <br />
                ¡Yo Confío en Tí Corazón Eucarístico de Jesús!
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>10 de Mayo de 1995</h6>
              <p>
                Mensaje de Jesús. <br />
                Cuando llegue el día del juicio, todos resucitarán, os lo
                aseguro, desde el primer hombre Adán y Eva, la primera mujer, y
                con ellos el último de los últimos y en ese día toda la creación
                estará expectante, cielos y tierra se verán. <br />
                <br />
                El Padre, El Hijo y El Espíritu Santo, la Gloria de las Glorias,
                benditos serán los benditos y malditos los malditos. <br />
                <br />
                Os he enviado a María mi Madre, el que la escucha a Mi me
                escucha.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>13 de Junio de 1995</h6>
              <p>
                Mensaje de Jesús. <br />
                El mundo nunca se preguntó, cuantas lágrimas derramé por
                vosotros durante mi Pasión y cuantas y amargas lágrimas derramó
                mi Santa Madre, para ayudar a la Redención, Yo les pido que
                honren cada lágrima que por vosotros derramé en esas horas
                amargas, prometo al que las honre rezando todos los días de su
                vida cinco Padrenuestros, cinco Avemarías y cinco Gloria. <br />
                <br />
                <strong>1)</strong> Asistirle junto a mi Santísima Madre, en la
                batalla final de su vida. <br />
                <br />
                <strong>2)</strong> La conversión total de su alma. <br />
                <br />
                <strong>3)</strong> Una verdadera contrición de sus pecados.{" "}
                <br />
                <br />
                <strong>4)</strong> En el día del juicio, perdonarlo para que
                entre Conmigo en la Gloria.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>31 de Octubre de 1995</h6>
              <p>
                Después de comulgar, tuve una visión, al cerrar los ojos para
                conversar con Jesús. El, se me apareció en el Rostro del Santo
                Sudario pero no como se ve, en una lámina o foto, sino real,
                todo su Rostro iluminado y con todos los padecimientos visibles,
                esto fue de un profundo efecto en mi alma. El, con sus Ojos
                cerrados me miraba el corazón y yo lo miraba con mi corazón.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>28 de Noviembre de 1995</h6>
              <p>
                Dice Jesús: <br />
                Nada negaré al alma que pida con confianza al SACRATISIMO
                CORAZON EUCARISTICO DE JESUS. <br />
                <br />
                Os llamo y os espero.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>30 de Noviembre de 1995</h6>
              <p>
                Después que recibí la Sagrada Comunión Jesús dice: <br />
                <br />
                “Yo Soy el Bien Infinito que sufre por las almas. Traedme almas
                a mi Corazón”
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>1 de Diembre de 1995 (PRIMER VIERNES)</h6>
              <p>
                Después de recibir la Sagrada Comunión Jesús dijo: <br />
                <br />
                Yo Soy “EL SACRATISIMO CORAZON EUCARISTICO DE JESUS” <br />
                <br />
                Acérquense a mi Corazón, no teman os favoreceré. Yo Soy el AMOR
                sin límites.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>13 de Diciembre de 1995</h6>
              <p>
                (después de la Sagrada Comunión) <br />
                <br />
                Jesús dice: <br />
                “Yo Soy el eterno Amante de las almas”. Mirad la Gloria de mi
                Divino Corazón, encendido con el fuego del Amor por ustedes,
                expuesto a todas las miradas. <br />
                <br />y tiene su rostro bañado de Lágrimas y antes de hablarme
                permite que mire su rostro.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>11 de Enero de 1996</h6>
              <p>
                Jesús dice: <br />
                <br />
                Con que derecho amonestáis a vuestros Sacerdotes, ¿no os enseñé
                a amaros unos a otros? <br />
                <br />
                Si vosotros sois mi pueblo y estáis corrompidos, cada uno de
                vosotros lleva una carga de pecado. Condonad primero vuestras
                deudas para que os perdone, sed verdaderos administradores míos
                para comenzar la obra de reparación en su justa medida, en el
                Santo Temor. Guardad las puertas de mi Reino con mi infinito
                Amor. <br /> <br />
                Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>18 de Enero de 1996</h6>
              <p>
                Dice Jesús: <br />
                <br />
                “Venid a Mí, todos los que estáis agobiados, os aliviaré de
                todas vuestras penas”. Venid a refugiaros en Mí Sagrado Corazón
                Eucarístico. <br />
                <br />
                Dice La Madre María Santísima: <br />
                <br />
                Cuando habla Mi Divino Hijo, Cielos y Tierra se postran en
                adoración. Cada Palabra de Dios, tiene el peso de toda la
                eternidad. Obedecedle y alabadlo por medio de la oración. <br />
                <br />
                Amén. Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>4 de Abril de 1996</h6>
              <p>
                Jesús dice: <br />
                <br />
                Contempladme y adoradme en mi Sacratísimo Corazón Eucarístico.
                Vosotros sois en MI, cuando coméis Mi Cuerpo y bebéis Mi Sangre;
                y mi infinito AMOR está en vosotros. <br />
                <br />
                Dice María Santísima: <br />
                <br />
                En el milagro de la SAGRADA EUCARISTIA, ustedes penetran en la
                intensidad de la TRINITARIA LUZ.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>24 de Mayo de 1996</h6>
              <p>
                Me dice Jesús: <br />
                <br />
                Quiero ser escuchado. <br />
                Te lo mando. <br />
                Habla al mundo de mi “Sacratísimo Corazón Eucarístico”. Que
                todos se acerquen a mi Infinito Amor con confianza. <br />
                <br />
                Dice la Santísima Madre: <br />
                <br />
                Volved vuestros ojos a Jesús Eucaristía, alimentaos con el Amor
                de su Sagrado Corazón, escuchad y amad a vuestro Dios. <br />
                <br />
                Amén. Amén.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>15 de Septiembre de 1996</h6>
              <p>
                Dice el Señor: <br />
                “Si quieren ser Míos, vengan a MI”.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>1 de Junio de 1997</h6>
              <p>
                (Solemnidad de Corpus Christi) <br />
                <br />
                Estando en oración vi a Nuestro Señor con gran magnificencia,
                gloria y esplendor. <br />
                <br />
                El me llamó por mi nombre. <br />
                <br />
                María: y dijo después ¡mírame...! <br />
                <br />
                Y vi en su pecho el impresionante Corazón de carne, rojo
                sangrante y palpitante. Sentí un inmenso calor como si estuviera
                dentro de una hoguera que me quemaba toda. Y a la vez una
                beatitud grande levantó mi alma hacia El. <br />
                <br />
                Comprendí que el Señor ¿no sé como? me había introducido en su
                Sagrado Corazón, allí sentí a la luz perfecta de Dios, la
                dulzura y suavidad de su AMOR. <br />
                <br />
                El Señor dijo: escucha con atención este mandato de mi Infinita
                Providencia. <br />
                <br />
                Adoradme y honradme por sobre todas las cosas en reparación y
                desagravio por los ultrajes, olvidos y sacrilegios que
                diariamente se cometen en el mundo entero al Sacramento de mi
                Divino Amor. <br />
                <br />
                CONSAGRAOS A MI SACRATISIMO CORAZON EUCARISTICO Y AL INMACULADO
                CORAZON DE MARIA, QUE EL MUNDO ENTERO SEA CONSAGRADO. <br />
                <br />
                Que sea conocida, propagada y llevada a cabo la "Adoración al
                Santísimo Sacramento, como verdadera devoción a mi Corazón vivo
                y presente en la Sagrada Eucaristía". <br />
                <br />
                Es tan grande mi Amor por las almas hija mía, que abriré las
                puertas del Cielo a todo aquel que me reciba y me complazca.{" "}
                <br />
                <br />
                Te bendigo hija mía con la fuerza de mi AMOR.
              </p>
            </div>
            <div className="col-12 mt-4">
              <h6>6 de Junio de 1997</h6>
              <p>
                (Solemnidad del Sagrado Corazón) <br />
                <br />
                El Señor dijo: <br />
                <br />
                ¡Sed todos míos! Abandonaos todos a Mí. <br />
                <br />
                ¡Confiad plenamente en Mí!. <br />
                <br />
                Acudid al fuego de mi Infinita Caridad.
              </p>
            </div>
          </div>
        </div>
      </div>
      <EsquinerosAbajo />
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
